import GammesProduitsController from './gammes.produits.controller';

export default {
    template: require('./gammes.produits.tpl.html'),
    controller: GammesProduitsController
};
